export default {
    name: 'specialMenu',
    state: {
        isSpecialMenu: false
    },
    getters: {
        getIsSpecialMenu: state => {
            return state.isSpecialMenu
        },
    },
    mutations: {
        SPECIALMENU: (state, payload) => {
            state.isSpecialMenu = payload;
        }
    },
    actions: {
        SET_SPECIALMENU(store, payload) {
            store.commit('SPECIALMENU', payload)
        }
    }
}